export default __webpack_public_path__ + "static/media/ds05.ee12fad8.jpg";